import { Column, Entity, Index } from 'typeorm';
import { BaseEntity } from './base.entity';

/**
 * PD-16038 — a plain email address looped in when an Issue of a given
 * "category" is created or updated, alongside the role and user rows in
 * issue_notification_role_config / issue_notification_user_config.
 *
 * Exists for shared mailboxes (a dispatch desk, an outside contractor) that
 * are not system users. Such an address gets the notification email only:
 * there is no user to write a bell row for and no per-user preference to
 * consult, which is exactly what a shared mailbox wants. One row per
 * (category, address); addresses are stored lower-cased and trimmed.
 */
@Index('UK_issue_notification_email_config', ['category', 'emailAddress'], {
	unique: true,
})
@Index('idx_issue_notification_email_config_category', ['category'], {})
@Entity('issue_notification_email_config')
export class IssueNotificationEmailConfigEntity extends BaseEntity {
	// A LinkableEntityType value (e.g. 'vehicle', 'client') or 'general'.
	@Column('varchar', { name: 'category', length: 50 })
	public category!: string;

	@Column('varchar', { name: 'emailAddress', length: 255 })
	public emailAddress!: string;
}
